const FOCUSABLE_SELECTOR =
	'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]'

/** Elements reachable with Tab, in DOM order. Roving `tabindex="-1"` items are excluded. */
export function getTabbableElements (container: HTMLElement): HTMLElement[] {
	return Array.from(
		container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)
	).filter(el => el.tabIndex >= 0)
}
